import ReactTable from 'react-table'
import styled from 'styled-components'
import { darken } from 'polished'
import naturalCompare from 'natural-compare'

import Color from 'helpers/Color'

const paginationCheck = ({ data }) => data ? data.length > 20 : false

const Table = styled(ReactTable).attrs({
  className: '-striped',
  showPaginationTop: paginationCheck,
  showPaginationBottom: paginationCheck,
  showPageSizeOptions: false,
  showPageJump: false,
  previousText: 'Previous Page',
  nextText: 'Next Page',
  minRows: 1,
  defaultSortMethod: () => naturalCompare,
})`
  border: 0;
  background-color: white;
  border-radius: 10px;
  margin: auto;
  width: 100%;

  .rt-tbody {
    .rt-td {
      border-right: 0;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0;
    }

    .rt-td a {
      display: block;
      height: 100%;
      padding: 10px;
      color: ${Color.green};
      font-weight: bold;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }

    .rt-tr-group {
      border-bottom: 0;
      min-height: 40px;
    }

    .rt-tr-group:last-child {
      .rt-tr {
        border-radius: 0 0 10px 10px;
      }
    }
  }

  .-pagination {
    box-shadow: none;
    border: 0;
    margin: 5px;

    .-btn {
      background-color: ${Color.green};
      color: ${Color.white};
      border-radius: 20px;
      padding: 10px;
      margin: auto;
      width: auto;
    }

    .-btn:not([disabled]):hover {
      background-color: ${darken(0.05, Color.green)};
    }

    .-btn:not([disabled]):active {
      background-color: ${darken(0.1, Color.green)};
    }
  }

  .rt-thead {
    &.-header {
      box-shadow: none;
      border-bottom: solid ${Color.gray} 2px;
      font-weight: bold;
    }

    &.-headerGroups {
      background: inherit;
      border-bottom: none;
      border-bottom: solid ${Color.gray} 2px;
    }

    .rt-th.-sort-asc {
      box-shadow: none;

      &:before {
        content: ' ';
        float: right;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid ${Color.green};
        top: 4px;
        right: 10px;
        position: relative;
        margin-left: 8px;
      }
    }

    .rt-th.-sort-desc {
      box-shadow: none;

      &:before {
        content: ' ';
        float: right;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${Color.green};
        top: 4px;
        right: 10px;
        position: relative;
      }
    }
  }
`

export default Table



// WEBPACK FOOTER //
// ./src/components/UI/Table.jsx